<template>
  <v-app>
    <v-app-bar app color="#ffffff" height="70">
      <v-toolbar-title class="d-flex align-center justify-start" @click="$vuetify.goTo('#hero')">
        <v-img
          src="~@/assets/logo.png"
          alt="Logo"
          contain
          height="40"
          max-width="40"
        ></v-img>
        <div class="font-weight-bold ml-2">
          <span>{{ app_details.name[lang] }}</span>
        </div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        text
        small
        class="hidden-sm-and-down grey--text text--darken-1"
        @click="$vuetify.goTo('#the-what')"
        >{{ navbar.what[lang] }}</v-btn
      >
      <v-btn
        text
        small
        class="hidden-sm-and-down grey--text text--darken-1"
        @click="$vuetify.goTo('#the-how')"
        >{{ navbar.how[lang] }}</v-btn
      >
      <v-btn
        text
        small
        class="hidden-sm-and-down text--darken-1"
        @click="$vuetify.goTo('#about-me')"
        >{{ navbar.about[lang] }}</v-btn
      >
      <v-btn
        text
        small
        class="hidden-sm-and-down text--lighten-1 mr-1"
        @click="$vuetify.goTo('#contact')"
        >{{ navbar.contact[lang] }}</v-btn
      >
      <v-btn
        text
        small
        class="hidden-sm-and-down text--lighten-1 mr-1"
        @click="$router.push('/status')"
        >{{ status.title[lang] }}</v-btn
      >
      <v-btn-toggle
        v-model="lang"
        mandatory
        borderless
        dense
        class="d-flex justify-end "
      >
        <v-btn
          value="en"
          x-small
          :color="lang === 'en' ? '#FF1531' : ''"
          :class="lang === 'en' ? 'white--text' : ''"
          class="flex text-center items-align-center"
        >
          EN
        </v-btn>
        <v-btn
          value="fr"
          x-small
          :color="lang === 'fr' ? '#FF1531' : ''"
          :class="lang === 'fr' ? 'white--text' : ''"
        >
          FR
        </v-btn>
      </v-btn-toggle>
      <v-menu
        v-if="$vuetify.breakpoint.smAndDown"
        offset-y
        left
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="hidden-md-and-up">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="$vuetify.goTo('#the-what')">
            <v-list-item-title>{{ navbar.what[lang] }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$vuetify.goTo('#the-how')">
            <v-list-item-title>{{ navbar.how[lang] }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$vuetify.goTo('#about-me')">
            <v-list-item-title>{{ navbar.about[lang] }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$vuetify.goTo('#contact')">
            <v-list-item-title>{{ navbar.contact[lang] }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$router.push('/status')">
            <v-list-item-title>{{ status.title[lang] }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>

    <v-content>
      <section id="hero" class="grey lighten-3">
        <v-row no-gutters class="hero-background">
          <v-col
            cols="12"
            md="6"
            class="clock-container"
            align-self="start"
            justify="center"
          >
          <div class="orbit-container md-hidden">
            <div class="red-dot"></div>
            <div class="red-dot-static"></div>
          </div>
          </v-col>
          <v-col
            cols="12"
            md="6"
            sm="12"
            align-self="start"
            class="mx-auto pt-md-16"
            justify="start"
          >
            <!-- Blank white background column -->
             <div class="sm:text-center md:text-left text-md-h4 text-lg-h3 white--text">
               <span> {{ app_details.name[lang] }}</span>
             </div>
             <div class="mt-5 text-md-subtitle-1 text-lg-h5 sm:text-center md:text-left white--text ">
               <span v-html="app_details.motto[lang]" />
             </div>
          </v-col>
        </v-row>
      </section>

      <section id="additional-info" class="grey lighten-3">
        <div class="py-4"></div>

        <v-container class="text-center" style="max-width: 90%;">
        <h2 class="display-1 font-weight-bold mb-6 teal--text text--darken-3">
          {{ headers.add_info[lang] }}
        </h2>

        <v-responsive class="mx-auto" width="56"> </v-responsive>

        <v-row>
        <v-col cols="12" md="4">
          <v-card
            class="py-12 px-4"
            color="grey lighten-5 elevate-paper"
            flat
            height="370"
          >
            <v-theme-provider dark>
              <div>
                <v-avatar size="88">
                  <v-img
                    width="45"
                    contain
                    height="45"
                    src="../assets/donate_icon.svg"
                    alt="Nanotechnology icon"
                  ></v-img>
                </v-avatar>
              </div>
            </v-theme-provider>

            <v-card-title
              class="justify-center font-weight-black text-uppercase"
              v-html="addInfo[0].title[lang]" />

            <v-expand-transition>
              <v-card
                v-if="addInfo[0].reveal"
                class="transition-fast-in-fast-out v-card--reveal"
                style="height: 100%;"
              >
              <v-card-title
                class="justify-center font-weight-black text-uppercase"
                v-html="addInfo[0].title[lang]" />
                <div class="pt-16 h-full d-flex justify-center text-center items-center w-full">
                    <div @click="onDonate()" style="cursor: pointer" class="mt-4 font-weight-bold display-1 primary---text justify-center text-center underline ">{{ addInfo[0].text[lang] }}</div>
                </div>
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card
            class="px-4 elevate-paper"
            color="grey lighten-5"
            flat
            height="370"
          >

            <v-card-title
              class="justify-center font-weight-black text-uppercase"
              v-html="addInfo[1].title[lang]" />

            <v-card-text
              class="subtitle-2"
            ><iframe
                width="100%"
                height="280"
                :src="addInfo[1].link"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4">
          <v-card
            class="py-4 px-4 elevate-paper"
            color="grey lighten-5"
            height="370"
            @click="gotoTimeooh()"
          >
            
            <v-theme-provider dark>
              <div >
                <div class="d-flex justify-center items-center w-full mx-auto mt-5">
                  <v-img
                    width="160"
                    contain
                    height="250"
                    src="../assets/projects/time-app.png"
                    alt="Timeooh App Image"
                  ></v-img>
                </div>
              </div>
            </v-theme-provider>

            <div class="d-flex justify-center items-center mx-auto logo-text">
              <v-col cols="12" md="12" class="d-flex justify-center align-center items-center text-start w-full pa-0 pt-5">
                <div class="font-weight-bold headline whitespace-nowrap">{{ addInfo[2].title[lang] }}</div>
              </v-col>
            </div>


            <v-expand-transition>
              <v-card
                v-if="addInfo[2].reveal"
                class="transition-fast-in-fast-out v-card--reveal"
                style="height: 100%;"
              >
            <v-card-title
              class="justify-center font-weight-black text-uppercase"
              v-html="theHow[2].title[lang]" />

                <v-card-text
                  class="subtitle-2"
                >{{theHow[2].text[lang]}}</v-card-text>

                <div class="d-flex justify-end mr-2">
                  <v-btn
                    text
                    class="button-end caption primary---text"
                    @click="theHow[2].reveal = false"
                  >
                    {{ misc.close[lang] }}
                  </v-btn>
                </div>
              </v-card>
            </v-expand-transition>
          </v-card>
        </v-col>
        </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>


      <section id="the-what" class="grey lighten-3 white">
        <div class="py-4"></div>

        <v-container class="text-center" style="max-width: 90%;">
          <h2 class="display-1 font-weight-bold mb-6 teal--text text--darken-3">
            {{ headers.what[lang] }}
          </h2>

          <v-responsive class="mx-auto" width="56"> </v-responsive>

          <v-row>
            <v-col cols="12" md="4">
              <v-card
                class="py-12 px-4"
                color="grey lighten-5 elevate-paper"
                flat
                height="370"
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar size="88">
                      <v-img
                        width="50"
                        contain
                        height="50"
                        src="../assets/octicon_goal-16.svg"
                        alt="Idea icon"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title class="justify-center font-weight-black text-uppercase"
                >{{theWhat[0].title[lang]}}</v-card-title>

                <v-card-text class="subtitle-2"
                >{{truncate(theWhat[0].text[lang])}}</v-card-text>
                <div
                  class="d-flex justify-end"
                  v-if="truncate(theWhat[0].text[lang]).endsWith('...')"
                >
                  <v-btn
                    text
                    class="button-end caption primary---text"
                    @click="theWhat[0].reveal = true"
                  >
                    {{ misc.readMore[lang] }}
                  </v-btn>
                </div>

                <v-expand-transition>
                  <v-card
                    v-if="theWhat[0].reveal"
                    class="transition-fast-in-fast-out v-card--reveal"
                    style="height: 100%;"
                  >
                    <v-card-title
                      class="justify-center font-weight-black text-uppercase"
                    >{{theWhat[0].title[lang]}}</v-card-title>

                    <v-card-text
                      class="subtitle-2"
                    >{{theWhat[0].text[lang]}}</v-card-text>

                    <div class="d-flex justify-end mr-2">
                      <v-btn
                        text
                        class="button-end caption primary---text"
                        @click="theWhat[0].reveal = false"
                      >
                        {{ misc.close[lang] }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-expand-transition>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card
                class="py-12 px-4 elevate-paper"
                color="grey lighten-5"
                flat
                height="370"
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar size="88">
                      <v-img
                        width="60"
                        contain
                        height="60"
                        src="../assets/ep_opportunity.svg"
                        alt="Processor icon"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                >{{theWhat[1].title[lang]}}</v-card-title>

                <v-card-text
                  class="subtitle-2"
                >{{truncate(theWhat[1].text[lang])}}
                </v-card-text>
                <div
                  class="d-flex justify-end"
                  v-if="truncate(theWhat[1].text[lang]).endsWith('...')"
                >
                  <v-btn
                    text
                    class="button-end caption primary---text"
                    @click="theWhat[1].reveal = true"
                  >
                    {{ misc.readMore[lang] }}
                  </v-btn>
                </div>

                <v-expand-transition>
                  <v-card
                    v-if="theWhat[1].reveal"
                    class="transition-fast-in-fast-out v-card--reveal"
                    style="height: 100%;"
                  >
                    <v-card-title
                      class="justify-center font-weight-black text-uppercase"
                    >{{theWhat[1].title[lang]}}</v-card-title>

                    <v-card-text
                      class="subtitle-2"
                    >{{theWhat[1].text[lang]}}</v-card-text>

                    <div class="d-flex justify-end mr-2">
                      <v-btn
                        text
                        class="button-end caption primary---text"
                        @click="theWhat[1].reveal = false"
                      >
                        {{ misc.close[lang] }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-expand-transition>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card
                class="py-12 px-4 elevate-paper"
                color="grey lighten-5"
                height="370"
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar size="88">
                      <v-img
                        width="50"
                        contain
                        height="50"
                        src="../assets/grommet-icons_technology.svg"
                        alt="Technology icon"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                >{{theWhat[2].title[lang]}}</v-card-title>

                <v-card-text
                  class="subtitle-2"
                >{{truncate(theWhat[2].text[lang])}}
                </v-card-text>
                <div
                  class="d-flex justify-end"
                  v-if="truncate(theWhat[2].text[lang]).endsWith('...')"
                >
                  <v-btn
                    text
                    class="button-end caption primary---text"
                    @click="theWhat[2].reveal = true"
                  >
                    {{ misc.readMore[lang] }}
                  </v-btn>
                </div>

                <v-expand-transition>
                  <v-card
                    v-if="theWhat[2].reveal"
                    class="transition-fast-in-fast-out v-card--reveal"
                    style="height: 100%;"
                  >
                    <v-card-title
                      class="justify-center font-weight-black text-uppercase"
                    >{{theWhat[2].title[lang]}}</v-card-title>

                    <v-card-text
                      class="subtitle-2"
                    >{{theWhat[2].text[lang]}}</v-card-text>

                    <div class="d-flex justify-end mr-2">
                      <v-btn
                        text
                        class="button-end caption primary---text"
                        @click="theWhat[2].reveal = false"
                      >
                        {{ misc.close[lang] }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>


      <section id="the-how" class="grey lighten-3">
        <div class="py-4"></div>

        <v-container class="text-center" style="max-width: 90%;">
          <h2 class="display-1 font-weight-bold mb-6 teal--text text--darken-3">
            {{ headers.how[lang] }}
          </h2>

          <v-responsive class="mx-auto" width="56"> </v-responsive>

          <v-row>
            <v-col cols="12" md="4">
              <v-card
                class="py-12 px-4"
                color="grey lighten-5 elevate-paper"
                flat
                height="370"
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar size="88">
                      <v-img
                        width="45"
                        contain
                        height="45"
                        src="../assets/Layer_1.svg"
                        alt="Nanotechnology icon"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-html="theHow[0].title[lang]" />

                <v-card-text
                  class="subtitle-2"
                >{{truncate(theHow[0].text[lang])}}</v-card-text>
                <div
                  class="d-flex justify-end"
                  v-if="truncate(theHow[0].text[lang]).endsWith('...')"
                >
                  <v-btn
                    text
                    class="button-end caption primary---text"
                    @click="theHow[0].reveal = true"
                  >
                    {{ misc.readMore[lang] }}
                  </v-btn>
                </div>

                <v-expand-transition>
                  <v-card
                    v-if="theHow[0].reveal"
                    class="transition-fast-in-fast-out v-card--reveal"
                    style="height: 100%;"
                  >
                  <v-card-title
                    class="justify-center font-weight-black text-uppercase"
                    v-html="theHow[0].title[lang]" />

                    <v-card-text
                      class="subtitle-2"
                    >{{theHow[0].text[lang]}}</v-card-text>

                    <div class="d-flex justify-end mr-2">
                      <v-btn
                        text
                        class="button-end caption primary---text"
                        @click="theHow[0].reveal = false"
                      >
                        {{ misc.close[lang] }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-expand-transition>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card
                class="py-12 px-4 elevate-paper"
                color="grey lighten-5"
                flat
                height="370"
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar size="88">
                      <v-img
                        width="50"
                        contain
                        height="50"
                        src="../assets/Layer_1(1).svg"
                        alt="Search icon"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-html="theHow[1].title[lang]" />

                <v-card-text
                  class="subtitle-2"
                >{{truncate(theHow[1].text[lang])}}
                </v-card-text>
                <div
                  class="d-flex justify-end"
                  v-if="truncate(theHow[1].text[lang]).endsWith('...')"
                >
                  <v-btn
                    text
                    class="button-end caption primary---text"
                    @click="theHow[1].reveal = true"
                  >
                    {{ misc.readMore[lang] }}
                  </v-btn>
                </div>

                <v-expand-transition>
                  <v-card
                    v-if="theHow[1].reveal"
                    class="transition-fast-in-fast-out v-card--reveal"
                    style="height: 100%;"
                  >
                  <v-card-title
                    class="justify-center font-weight-black text-uppercase"
                    v-html="theHow[1].title[lang]" />
                    <v-card-text
                      class="subtitle-2"
                    >{{theHow[1].text[lang]}}</v-card-text>

                    <div class="d-flex justify-end mr-2">
                      <v-btn
                        text
                        class="button-end caption primary---text"
                        @click="theHow[1].reveal = false"
                      >
                        {{ misc.close[lang] }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-expand-transition>
              </v-card>
            </v-col>
            <v-col cols="12" md="4">
              <v-card
                class="py-12 px-4 elevate-paper"
                color="grey lighten-5"
                height="370"
              >
                <v-theme-provider dark>
                  <div>
                    <v-avatar size="88">
                      <v-img
                        width="50"
                        contain
                        height="50"
                        src="../assets/Layer_1(2).svg"
                        alt="Mechanism icon"
                      ></v-img>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-html="theHow[2].title[lang]" />

                <v-card-text
                  class="subtitle-2"
                >{{truncate(theHow[2].text[lang])}}
                </v-card-text>
                <div
                  class="d-flex justify-end"
                  v-if="truncate(theHow[2].text[lang]).endsWith('...')"
                >
                  <v-btn
                    text
                    class="button-end caption primary---text"
                    @click="theHow[2].reveal = true"
                  >
                    {{ misc.readMore[lang] }}
                  </v-btn>
                </div>

                <v-expand-transition>
                  <v-card
                    v-if="theHow[2].reveal"
                    class="transition-fast-in-fast-out v-card--reveal"
                    style="height: 100%;"
                  >
                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-html="theHow[2].title[lang]" />

                    <v-card-text
                      class="subtitle-2"
                    >{{theHow[2].text[lang]}}</v-card-text>

                    <div class="d-flex justify-end mr-2">
                      <v-btn
                        text
                        class="button-end caption primary---text"
                        @click="theHow[2].reveal = false"
                      >
                        {{ misc.close[lang] }}
                      </v-btn>
                    </div>
                  </v-card>
                </v-expand-transition>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="about-me">

        <v-container class="text-center">
          <h2 class="display-1 font-weight- mb-3 mt-8 teal--text text--darken-3">
            {{ headers.about[lang] }}
          </h2>

          <v-responsive class="mx-auto mb-4" width="56"> </v-responsive>

          <v-responsive
            class="mx-auto title font-weight-light mb-8"
            max-width="760"
          >
            <span v-html="aboutContent[lang]"></span>
            <div class="my-9 bg-color-red"></div>
            <div
              class="subtitle-1 font-weight-bold"
              v-html="aboutContentPoints[lang]"
            ></div>
          </v-responsive>

          <div v-show="false">
            <!-- Management -->
            <div class="d-flex justify-center mb-5">
              <span class="teal--text text--darken-2 text-h5 font-weight-bold">
                {{headers.management[lang]}}
              </span>
            </div>
            <div class="d-flex flex-sm-row flex-column justify-center align-center px-15">
              <v-card class="mx-5 d-flex mb-5" @mouseover="()=>setupBackground(0)" @mouseleave="setupBackground()" height="280" :width="showBackground[0]?'440':'220'">
                <div class="d-flex flex-column align-center">
                  <v-img
                    class="d-flex justify-right align-end"
                    contain
                    width="220"
                    height="220"
                    src="../assets/images/philip.png"
                    alt="CEO"
                  >
                  </v-img>

                  
                  <div class="px-2 mb-8 mt-2 w-full d-flex justify-space-between">
                    <div class=" d-flex flex-column align-start">
                      <span class="text-headline font-weight-bold">Philip Anani</span>
                      <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.founder[lang]}}</span>
                    </div>
                    <div class="d-flex justify-end align-end">
                      <v-icon class="teal--text lighten-1">{{showBackground[0] ? 'mdi-arrow-left' : 'mdi-arrow-right'}}</v-icon>
                    </div>
                  </div>
                </div>
                <v-slide-x-transition hide-on-leave>
                  <div class="body-2 pa-2 px-4 text-left" height="220" v-show="showBackground[0]">
                    Entrepreneur (Social &amp; Digital Space)<br/>
                    Former Head of Public Affaires &amp; Corporate Communications Nestle (Central West Africa)<br/><br/>
                    <b>Education:</b><br/>
                    BA - Architecture Lausanne (CH)<br/>
                    MBA - OUBS, UK
                  </div>
                </v-slide-x-transition>
              </v-card>

              <v-card class="mx-5 d-flex mb-5" @mouseover="()=>setupBackground(1)" @mouseleave="setupBackground()" height="280" :width="showBackground[1]?'440':'220'">
                <div class="d-flexbold flex-column align-center">
                  <v-img
                    class="d-flex justify-right align-end"
                    contain
                    width="220"
                    height="220"
                    src="../assets/images/alex.jpg"
                    alt="CEO"
                  >
                  </v-img>                  
                  <div class="px-2 mb-8 mt-2 w-full d-flex justify-space-between">
                    <div class=" d-flex flex-column align-start">
                      <span class="text-headline font-weight-bold">Alexandre Gedrinsky</span>
                      <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.founder[lang]}}</span>
                    </div>
                    <div class="d-flex justify-end align-end">
                      <v-icon class="teal--text lighten-1">{{showBackground[1] ? 'mdi-arrow-left' : 'mdi-arrow-right'}}</v-icon>
                    </div>
                  </div>
                </div>
                <v-slide-x-transition hide-on-leave>
                  <div class="body-2 pa-2 px-4 text-left" height="220" v-show="showBackground[1]">
                    Commodity Trader (Areas of Expertise, Cocoa and Supply Chain)<br/>
                    Former Senior Trader, Stone X Group (US), Barry Callebaut (CH)<br/>
                    <br/>
                    <b>Education:</b><br/>
                    BA - McGill Uni. Canada<br/>
                    MBA - Uni. Paris Dauphine, France<br/>
                  </div>
                </v-slide-x-transition>
              </v-card>
            </div>

            <!-- Development Team -->
            <div class="d-flex justify-center mt-16 mb-5">
              <span class="teal--text text--darken-2 text-h5 font-weight-bold">
                {{headers.development_team[lang]}}
              </span>
            </div>
            <div class="d-flex flex-sm-row flex-column justify-center align-center px-15">

              <v-card class="mx-5 d-flex mb-5" @mouseover="()=>setupBackground(2)" @mouseleave="setupBackground()" height="280" :width="showBackground[2]?'440':'220'">
                <div class="d-flex flex-column align-center">
                  <v-img
                    class="d-flex justify-right align-end"
                    contain
                    width="220"
                    height="220"
                    src="../assets/images/louis.png"
                    alt="CEO"
                  >
                  </v-img>                  
                  <div class="px-2 mb-8 mt-2 w-full d-flex justify-space-between">
                    <div class=" d-flex flex-column align-start">
                      <span class="text-headline font-weight-bold">Louis Adjanohoun</span>
                      <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.software_engineer[lang]}}</span>
                    </div>
                    <div class="d-flex justify-end align-end">
                      <v-icon class="teal--text lighten-1">{{showBackground[2] ? 'mdi-arrow-left' : 'mdi-arrow-right'}}</v-icon>
                    </div>
                  </div>
                </div>
                <v-slide-x-transition hide-on-leave>
                  <div class="body-2 pa-2 px-4 text-left" height="220" v-show="showBackground[2]">
                    <b>Area:</b><br/>
                    Senior Software Developer in the Tech industry, 
                    with techincal and coding proficiency in; 
                    Flutter, Java, Ruby on Rails, 
                    VueJS, Android development etc.<br/>
                    <br/>
                    <b>Education:</b><br/>
                    Bsc. GTUC, Ghana 
                  </div>
                </v-slide-x-transition>
              </v-card>

              <v-card class="mx-5 d-flex mb-5" @mouseover="()=>setupBackground(3)" @mouseleave="setupBackground()" height="280" :width="showBackground[3]?'440':'220'">
                <div class="d-flex flex-column align-center">
                  <v-img
                    class="d-flex justify-right align-end"
                    contain
                    width="220"
                    height="220"
                    src="../assets/images/princewill.png"
                    alt="CEO"
                  >
                  </v-img>                  
                  <div class="px-2 mb-8 mt-2 w-full d-flex justify-space-between">
                    <div class=" d-flex flex-column align-start">
                      <span class="text-headline font-weight-bold">Princewill Edomobi</span>
                      <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.software_engineer[lang]}}</span>
                    </div>
                    <div class="d-flex justify-end align-end">
                      <v-icon class="teal--text lighten-1">{{showBackground[3] ? 'mdi-arrow-left' : 'mdi-arrow-right'}}</v-icon>
                    </div>
                  </div>
                </div>
                <v-slide-x-transition hide-on-leave>
                  <div class="body-2 pa-2 px-4 text-left" height="220" v-show="showBackground[3]">
                    <b>Area:</b><br/>
                    Senior Software Developer in the Tech industry, 
                    with techincal and coding proficiency in; 
                    Javascript, Ruby, Ruby on Rails, 
                    VueJS, Android development etc.<br/>
                    <br/>
                    <b>Education:</b><br/>
                    Bsc. GTUC, Ghana 
                  </div>
                </v-slide-x-transition>
              </v-card>

              <v-card class="mx-5 d-flex mb-5" @mouseover="()=>setupBackground(4)" @mouseleave="setupBackground()" height="280" :width="showBackground[4]?'440':'220'">
                <div class="d-flex flex-column align-center">
                  <v-img
                    class="d-flex justify-right align-end"
                    contain
                    width="220"
                    height="220"
                    src="../assets/images/isaac.png"
                    alt="CEO"
                  >
                  </v-img>                  
                  <div class="px-2 mb-8 mt-2 w-full d-flex justify-space-between">
                    <div class=" d-flex flex-column align-start">
                      <span class="text-headline font-weight-bold">Isaac Boateng</span>
                      <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.UIUX[lang]}}</span>
                    </div>
                    <div class="d-flex justify-end align-end">
                      <v-icon class="teal--text lighten-1">{{showBackground[4] ? 'mdi-arrow-left' : 'mdi-arrow-right'}}</v-icon>
                    </div>
                  </div>
                </div>
                <v-slide-x-transition hide-on-leave>
                  <div class="body-2 pa-2 px-4 text-left" height="220" v-show="showBackground[4]">
                    <b>Area:</b><br/>
                    Designer &amp; UI/UX Engineer etc. with proficiency in popular design tools like; Photoshop, 
                    Adobe Illustrator and Figma.<br/>
                    <br/>
                    <b>Education:</b><br/>
                    Bsc. KNUST, Ghana
                  </div>
                </v-slide-x-transition>
              </v-card>
            </div>
            
            <!-- Advisory Board -->
            <div class="d-flex justify-center mt-16 mb-5">
              <span class="teal--text text--darken-2 text-h5 font-weight-bold">
                {{headers.advisory_board[lang]}}
              </span>
            </div>
            <div class="d-flex flex-sm-row flex-column justify-center align-center px-15">

              <v-card class="mx-5 d-flex mb-5" @mouseover="()=>setupBackground(5)" @mouseleave="setupBackground()" height="280" :width="showBackground[5]?'440':'220'">
                <div class="d-flex flex-column align-center">
                  <v-img
                    class="d-flex justify-right align-end"
                    contain
                    width="220"
                    height="220"
                    src="../assets/images/fatu.png"
                    alt="CEO"
                  >
                  </v-img>                  
                  <div class="px-2 mb-8 mt-2 w-full d-flex justify-space-between">
                    <div class=" d-flex flex-column align-start">
                      <span class="text-headline font-weight-bold">Fatu Gbedema</span>
                      <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.development_specialist[lang]}}</span>
                    </div>
                    <div class="d-flex justify-end align-end">
                      <v-icon class="teal--text lighten-1">{{showBackground[5] ? 'mdi-arrow-left' : 'mdi-arrow-right'}}</v-icon>
                    </div>
                  </div>
                </div>
                <v-slide-x-transition hide-on-leave>
                  <div class="body-2 pa-2 px-4 text-left" height="220" v-show="showBackground[5]">
                    International Development, Public-Relations and Human Capital Consultant. Region, West Africa.<br/>
                    <br/>
                    <b>Education:</b><br/>
                    BA - Uni. of Liberia, Liberia<br/>
                    MA - Uni. of Ghana, Ghana<br/>
                    MSc. - Uni. of Maryland, USA<br/>
                  </div>
                </v-slide-x-transition>
              </v-card>

              <v-card class="mx-5 d-flex mb-5" @mouseover="()=>setupBackground(6)" @mouseleave="setupBackground()" height="280" :width="showBackground[6]?'440':'220'">
                <div class="d-flex flex-column align-center">
                  <v-img
                    class="d-flex justify-right align-end"
                    contain
                    width="220"
                    height="220"
                    src="../assets/images/vincent.png"
                    alt="CEO"
                  >
                  </v-img>                  
                  <div class="px-2 mb-8 mt-2 w-full d-flex justify-space-between">
                    <div class=" d-flex flex-column align-start">
                      <span class="text-headline font-weight-bold">Vincent Servant</span>
                      <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.financial_specialist[lang]}}</span>
                    </div>
                    <div class="d-flex justify-end align-end">
                      <v-icon class="teal--text lighten-1">{{showBackground[6] ? 'mdi-arrow-left' : 'mdi-arrow-right'}}</v-icon>
                    </div>
                  </div>
                </div>
                <v-slide-x-transition hide-on-leave>
                  <div class="body-2 pa-2 px-4 text-left" height="220" v-show="showBackground[6]">
                    Finance (Banking Sector, Financial Instruments)
                    Former Head of Trading, Equity &amp; Fixed Income, Syz.<br/>
                    Bank, BCV, (CH) Deutsche<br/>
                    Bank (France), respectively.<br/>
                    <br/>
                    <b>Education:</b><br/>
                    MBA - Uni. Paris Dauphine, France
                  </div>
                </v-slide-x-transition>
              </v-card>
            </div>

          </div>

          <div v-show="showImages">
            <div class="d-flex flex-column justify-center align-center px-15">
              <v-card
              elevation="10"
              class="rounded-circle">
                <v-img
                  class="d-flex justify-center align-center rounded-circle"
                  contain
                  width="220"
                  height="220"
                  src="../assets/images/tymmo.jpg"
                  alt="president photo"
                >
              </v-img>
            </v-card>
              <div class="px-2 mb-8 mt-2 w-full d-flex justify-center items-center">
                <div class=" d-flex flex-column align-center">
                  <span class="text-headline font-weight-bold">Tymmo von Wild</span>
                  <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.president[lang]}}</span>
                </div>
              </div>
            </div>

            <div class="d-flex flex-column flex-md-row justify-center align-center px-15">
              <div class="d-flex flex-column justify-center align-center px-15">
                <v-card
                  elevation="10"
                  class="rounded-circle">
                  <v-img
                        class="d-flex justify-center align-center rounded-circle"
                        contain
                        width="220"
                        height="220"
                        src="../assets/images/alex.jpg"
                        alt="secretary photo"
                      >
                  </v-img>
                </v-card>
                <div class="px-2 mb-8 mt-2 w-full d-flex justify-center items-center">
                  <div class=" d-flex flex-column align-center">
                    <span class="text-headline font-weight-bold">Alexandre Gedrinsky</span>
                    <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.secretary[lang]}}</span>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column justify-center align-center px-15">
                <v-card
                  elevation="10"
                  class="rounded-circle">
                      <v-img
                      class="d-flex justify-center align-center rounded-circle"
                      contain
                      width="220"
                      height="220"
                      src="../assets/images/abdirashid.jpg"
                      alt="communication photo"
                    >
                  </v-img>
                </v-card>
                <div class="px-2 mb-8 mt-2 w-full d-flex justify-center items-center">
                  <div class=" d-flex flex-column align-center">
                    <span class="text-headline font-weight-bold">Abdirashid Egal</span>
                    <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.communication[lang]}}</span>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column justify-center align-center px-15">
                <v-card
                  elevation="10"
                  class="rounded-circle">
                    <v-img
                      class="d-flex justify-center align-center rounded-circle"
                      contain
                      width="220"
                      height="220"
                      src="../assets/images/libirio.jpg"
                      alt="treasury photo"
                    >
                  </v-img>
                </v-card>
                <div class="px-2 mb-8 mt-2 w-full d-flex justify-center items-center">
                  <div class=" d-flex flex-column align-center">
                    <span class="text-headline font-weight-bold">Liborio Mogavero-Despland</span>
                    <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.treasury[lang]}}</span>
                  </div>
                </div>
              </div>
            </div>


            <div class="d-flex flex-column justify-center align-center px-15">
              <v-card
              elevation="10"
              class="rounded-circle">
                <v-img
                  class="d-flex justify-center align-center rounded-circle"
                  contain
                  width="220"
                  height="220"
                  src="../assets/images/philip.png"
                  alt="advisor photo"
                >
              </v-img>
            </v-card>
              <div class="px-2 mb-8 mt-2 w-full d-flex justify-center items-center">
                <div class=" d-flex flex-column align-center">
                  <span class="text-headline font-weight-bold">Philip Anani</span>
                  <span class="text-body-2 font-weight-normal teal--text">{{teamTitles.member[lang]}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-16 d-flex flex-column justify-center align-center" v-show="!showImages">
            <a @click="showImages = !showImages">
              <span class="teal--text font-weight-bold text--darken-1 text-h5">
                {{ showImages ? "" : misc.theTeam[lang] }}
              </span>
            </a>
          </div>


          <div></div>

          <v-btn
            color="grey"
            v-if="false"
            href="https://www.linkedin.com/in/gordon%2Danani%2D57521386/"
            outlined
            large
          >
            <span class="grey--text text--darken-1 font-weight-bold">
              LINKED IN
            </span>
          </v-btn>
        </v-container>

        <div class="py-7"></div>
      </section>

      <v-divider></v-divider>

      <v-sheet id="contact" color="white" dark tag="section" tile>
        <v-container>
          <div class="d-flex justify-center">
            <h2 class="display-1 font-weight-bold mt-10 mb-5 teal--text text--darken-3">
              {{ headers.contact[lang] }}
            </h2>
          </div>
          <v-responsive class="mx-auto" width="56"> </v-responsive>
          <v-row>
            <!-- Contact Us-->
            <v-col cols="12" md="6" class="d-flex justify-center">
              <v-card
                width="525"
                color="grey lighten-3"
                class="mt-1 elevate-paper"
              >
                <a
                  target="_blank"
                  href="https://www.google.com/maps/place/Chem.+de+la+Begoudaz+6,+1262+Eysins,+Switzerland/@46.383448,6.2042531,17z/data=!3m1!4b1!4m6!3m5!1s0x478c5d213cf3dac9:0x3f4317d24014b8a3!8m2!3d46.383448!4d6.206828!16s%2Fg%2F11fb0hzn1y?entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D"
                  ><v-img
                    height="250"
                    src="../assets/map-loc-img3.png"
                    alt="Location of Address"
                  ></v-img
                ></a>

                <v-card-text class=" grey--text text--darken-4 pb-0">
                  <div class="d-flex justify-center">
                    <a
                      class="primary---text"
                      target="_blank"
                      href="https://www.google.com/maps/place/Chem.+de+la+Begoudaz+6,+1262+Eysins,+Switzerland/@46.383448,6.2042531,17z/data=!3m1!4b1!4m6!3m5!1s0x478c5d213cf3dac9:0x3f4317d24014b8a3!8m2!3d46.383448!4d6.206828!16s%2Fg%2F11fb0hzn1y?entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D"
                      >Chemin de la Begoudaz 6 1262 Eysins VD, Switzerland.</a
                    >
                  </div>
                </v-card-text>

                <v-card-text>
                  <div
                    class="grey--text text--darken-4"
                    style="text-align:center;"
                  >
                    {{ contactHeader.text[lang] }}
                  </div>
                </v-card-text>

                <v-divider class="mx-1" light></v-divider>

                <v-card-title class="grey--text text--darken-4 pb-0">{{
                  misc.reachUs[lang]
                }}</v-card-title>

                <v-card-text style="display:flex;">
                  <v-chip-group active-class="deep-purple accent-4 white--text">
                    <v-chip color="#10A087" label><span class="white--text">admin@human-time.org</span></v-chip>
                    <!-- <v-chip color="cyan darken-3">+41 (77) 503 36 56</v-chip> -->
                  </v-chip-group>
                </v-card-text>
              </v-card>
            </v-col>

            <!-- Contact form -->
            <v-col cols="12" md="6" class="d-flex justify-center">
              <v-card width="525" elevation="0" color="transparent">
                <v-theme-provider light>
                  <v-row>
                    <!-- First name -->
                    <v-col cols="6" class="pt-0">
                      <v-text-field
                        :label="contactHeader.firstname[lang]"
                        v-model="contact.firstname"
                        @input="alert = false"
                      ></v-text-field>
                    </v-col>
                    <!-- Last name -->
                    <v-col cols="6" class="pt-0">
                      <v-text-field
                        :label="contactHeader.lastname[lang]"
                        v-model="contact.lastname"
                        @input="alert = false"
                      ></v-text-field>
                    </v-col>
                    <!-- Email -->
                    <v-col cols="12">
                      <v-text-field
                        :label="contactHeader.email[lang]"
                        v-model="contact.email"
                        @input="alert = false"
                      ></v-text-field>
                    </v-col>
                    <!-- Subject -->
                    <v-col cols="12" class="mb-2">
                      <v-select
                        v-model="contact.subject"
                        :items="subjects.map(x => x[lang])"
                        :label="contactHeader.subject[lang]"
                        @input="alert = false"
                      ></v-select>
                    </v-col>
                    <!-- Message -->
                    <v-col cols="12" class="">
                      <v-textarea
                        :label="contactHeader.message[lang]"
                        v-model="contact.message"
                        @input="alert = false"
                      ></v-textarea>
                    </v-col>
                    <!-- Error -->
                    <v-col cols="12">
                      <v-alert
                        text
                        dense
                        :value="alert"
                        type="error"
                        class="mb-0"
                      >
                        {{ alertText }}
                      </v-alert>
                    </v-col>
                    <!-- Submit -->
                    <v-col cols="12" class="py-0">
                      <v-btn
                        width="100%"
                        color="#10A087"
                        @click="submit()"
                      >
                        <span class="white--text">{{ misc.submit[lang] }}</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-theme-provider>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-content>

    <v-snackbar v-model="snackbar" :timeout="timeout" color="success">
      {{ misc.thanks[lang] }}
    </v-snackbar>

    <v-footer class="justify-center" color="#ffffff" height="50" elevation="5">
      <div
        class="subtitle-2 font-weight-bold grey--text text--darken-2 text-center"
      >
        {{ misc.copyright[lang] }} &copy; {{ new Date().getFullYear() }}
        {{ app_details.name[lang] }}
      </div>
    </v-footer>
  </v-app>
</template>
<script>
import emailjs from "@emailjs/browser";
import translations from "@/translations/home";
export default {
  name: "home",
  components: {},
  mixins: [translations],
  data() {
    return {
      contact: {
        firstname: "",
        lastname: "",
        email: "",
        subject: "",
        message: ""
      },
      SERVICE_ID: "service_97uoomq",
      TEMPLATE_ID: "template_ec8nsfg",
      alert: false,
      alertText: "",
      snackbar: false,
      timeout: 1500,
      lang: "fr",
      showImages: false,
      showBackground: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ]
    };
  },
  mounted() {
    this.contact.subject = this.subjects[0][this.lang];
    emailjs.init({publicKey: "GoZFBaxH4_QPFosah"} );
  },
  watch: {
    lang: {
      handler(newVal) {
        if (newVal) {
          this.TEMPLATE_ID =
            newVal === "en" ? "template_k6v7ljf" : "template_lfkb29j";
          this.contact.subject = this.subjects[0][newVal];
          this.validating(true);
        }
      }
    }
  },
  methods: {
    async submit() {
      this.validating();
      if (this.alertText != "") {
        return;
      }
      try {
        emailjs.send(
          this.SERVICE_ID,
          this.TEMPLATE_ID,
          {
            subject: this.contact.subject,
            name: `${this.contact.firstname} ${this.contact.lastname}`,
            email: this.contact.email,
            message: this.contact.message,
            reply_to: this.contact.email
          }
        );
        this.snackbar = true;
        this.contact = {
          name: "",
          email: "",
          subject: this.subjects[0][this.lang],
          message: ""
        };
      } catch (error) {
        console.log(error);
      }
    },
    validating(fromLang) {
      if (fromLang && !this.alert) return;
      this.alert = true;
      if (this.contact.firstname == "" || this.contact.lastname == "") {
        this.alertText =
          this.lang === "en"
            ? "Please fill out your name"
            : "Veuillez indiquer votre nom";
        return;
      }
      if (this.contact.email == "") {
        this.alertText =
          this.lang === "en"
            ? "Please fill out your email"
            : "Veuillez remplir votre email";
        return;
      }
      if (!this.validEmail(this.contact.email)) {
        this.alertText =
          this.lang === "en"
            ? "Email is not valid"
            : "L'e-mail n'est pas valide";
        return;
      }
      if (this.contact.subject == "") {
        this.alertText =
          this.lang === "en"
            ? "Please fill out a subject"
            : "Veuillez remplir un sujet";
        return;
      }
      if (this.contact.message == "") {
        this.alertText =
          this.lang === "en"
            ? "Please fill out a message"
            : "Merci de remplir un message";
        return;
      }
      this.alert = false;
      this.alertText = "";
      return;
    },
    validEmail(email) {
      return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      );
    },
    onDonate(){
      // scroll to id contact

      const element = document.getElementById("contact");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
      
      // set subject to donation
      this.contact.subject = this.subjects[1][this.lang];
      this.contact.message = this.lang === 'en' ? "I would like to donate" : "Je voudrais faire un don";

    },
    ////////////////////////////////////////////
    showModal(index) {
      index;
    },
    truncate(text) {
      let count = 100;
      let result = "";
      let i = 0;
      let stop = false;
      while (!stop) {
        if (text[i]) {
          result += text[i];
        }
        i++;
        if (i > count && text[i] === " ") {
          stop = true;
        }
      }
      return result === text ? result : result + "...";
    },
    setupBackground(index){
      for(let i=0;i<this.showBackground.length;i++){
        this.showBackground[i] = false;
      }
      if(index !== undefined || index !== null)
        this.showBackground[index] = true;


      this.$forceUpdate(); 
    },
    donate(amount){
      console.log('Donating', amount);
    },
    gotoTimeooh(){
      window.open('https://timeooh.com', '_blank');
    }
  }
};
</script>
<style scoped>
.v-main .v-content {
  padding: 0px 0px 0px !important;
}
.v-application {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
.v-application .subtitle-1 {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
.v-application .headline {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
.v-application .body-1 {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
.v-application .subtitle-2 {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
.v-application .title {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

.v-application .title-big {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 1.5rem !important;
}
.v-application .display-1 {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 1.8rem !important;
}
.v-application .display-2 {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
.v-application .display-1a {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 1.5rem !important;
  font-weight: normal;
}
.v-application .display-2a {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 2rem !important;
  font-weight: normal;
}
.v-application .display-3 {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
.v-application .display-4 {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}
.v-text-field {
  height: 50px;
}
.v-text-field.v-textarea {
  height: 163px;
}
.bg-img {
  background-image: url("../assets/teclinker-bg-scaled.jpg");
}
.bottom-pos {
  margin-top: 35%;
}
.no-padding {
  padding: 0px !important;
}
.center {
  margin: auto;
}

.elevate-paper {
  box-shadow: 1px 1px 1px 0px rgba(0, 0, 0, 0.2),
    2px 2px 2px 0px rgba(0, 0, 0, 0.14), 3px 3px 3px 0px rgba(0, 0, 0, 0.12) !important;
}

.v-card--reveal {
  bottom: 0;
  left: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}

.v-card--reveal-how {
  top: 0;
  left: 0;
  opacity: 1 !important;
  position: absolute;
  height: 370px;
  width: 102%;
}

.center-text {
  text-align: center;
}
.start-text {
  text-align: start;
}
.left-text {
  text-align: left;
}

.button-end {
  position: absolute;
  bottom: 0;
  right: 0;
}
.button-end-l {
  position: absolute;
  bottom: 0;
  left: 0;
}
.v-window__next,
.v-window__prev {
  background: none !important;
}

.bg-color-red {
  background-color: #10A087;
  height: 2px;
  margin-left: 20%;
  margin-right: 20%;
}
.primary---text {
  color: #10A087 !important;
}
.w-full{
  width: 100%;
}
.image-container {
  position: relative;
  border-radius: 500px;
  overflow: hidden;
  width: 40vw;
  height: 40vw;
}
.green-tint {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(52, 160, 141, 0.8); /* Adjust the rgba value to control the tint color and opacity */
  mix-blend-mode: multiply;
}

.hero-background {
  padding: 20px;
  background-image: url('../assets/timeooh hero image.jpg'); /* Replace with your image path */
  background-position: top;
  background-repeat: no-repeat;
  height: 73vh;
}

.hero-background {
  background-size: contain;
}

.orbit-container {
  position: relative;
  width: 30vw;  /* Responsive width */
  height: 30vw; /* Keep it square */
  background-image: url('../assets/timeooh clock.png'); /* Replace with your image path */
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.red-dot {
  width: 15px;
  height: 15px;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  top: 48%;
  left: 48%;
  transform: translate(-50%, -12vw); /* Adjust orbit radius */
  animation: orbit 60s steps(60) infinite;
}

.clock-container {
  height: 34vw;
  justify-content: center;
  display: flex;
  align-items: center;
}

.red-dot-static {
  width: 25px;
  height: 25px;
  background-color: red;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 47%;
}
.whitespace-nowrap {
  white-space: nowrap;
}

@keyframes orbit {
  0% {
    transform: rotate(2deg) translate(-50%, -12vw) rotate(0deg);
  }
  100% {
    transform: rotate(362deg) translate(-50%, -12vw) rotate(-360deg);
  }
}

@media (max-width: 1065px) {
  .v-application .display-3 {
    font-size: 2.5rem !important;
    font-weight: 400 !important;
  }
}

@media (max-width: 960px) {
  .hero-background {
    background-size: cover;
  }

  .md-hidden {
    display: none;
  }
}

.logo-text {
  width: 205px;
}

@media (max-width: 450px) {
  .logo-text {
    width: 105px;
  }
}
</style>
